// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Recoil from "recoil";
import * as Core__JSON from "@rescript/core/src/Core__JSON.bs.js";
import * as Core__Option from "@rescript/core/src/Core__Option.bs.js";
import * as Core__Promise from "@rescript/core/src/Core__Promise.bs.js";
import * as Utils$OrcaPaymentPage from "./Utils.bs.js";
import * as APIUtils$OrcaPaymentPage from "./APIHelpers/APIUtils.bs.js";
import * as ApiEndpoint$OrcaPaymentPage from "./ApiEndpoint.bs.js";
import * as BrowserSpec$OrcaPaymentPage from "../BrowserSpec.bs.js";
import * as LoggerUtils$OrcaPaymentPage from "./LoggerUtils.bs.js";
import * as RecoilAtoms$OrcaPaymentPage from "./RecoilAtoms.bs.js";
import * as PaymentError$OrcaPaymentPage from "../Types/PaymentError.bs.js";
import * as RecoilAtomsV2$OrcaPaymentPage from "./RecoilAtomsV2.bs.js";
import * as PaymentConfirmTypesV2$OrcaPaymentPage from "../Types/PaymentConfirmTypesV2.bs.js";

function normalizeIsoUtc(s) {
  return s.trim().replace(/ ([+-]\d{2}:\d{2})(?::\d{2})?$/, "$1").replace(/ /, "T");
}

function invoiceExpirySeconds(invoice) {
  var numericExpiresAt = Utils$OrcaPaymentPage.getFloat(invoice, "expires_at", 0.0);
  if (numericExpiresAt > 0.0) {
    return numericExpiresAt;
  }
  var legacyExpiryAt = Utils$OrcaPaymentPage.getFloat(invoice, "expiry_at", 0.0);
  if (legacyExpiryAt > 0.0) {
    return legacyExpiryAt;
  }
  var rawExpiresAt = Utils$OrcaPaymentPage.getString(invoice, "expires_at", "");
  var parsedMs = rawExpiresAt === "" ? 0.0 : Date.parse(normalizeIsoUtc(rawExpiresAt));
  if (parsedMs === parsedMs && parsedMs > 0.0) {
    return parsedMs / 1000.0;
  } else {
    return 0.0;
  }
}

function buildNativeCryptoMetadata(invoice, paymentId, clientSecret, profileId, publishableKey, returnUrl) {
  var value = Utils$OrcaPaymentPage.getString(invoice, "address", "");
  var address = value === "" ? Utils$OrcaPaymentPage.getString(invoice, "receive_address", "") : value;
  var amountMinorNew = Utils$OrcaPaymentPage.getFloat(invoice, "amount_minor", 0.0);
  var amountMinor = amountMinorNew === 0.0 ? Utils$OrcaPaymentPage.getFloat(invoice, "expected_amount_minor", 0.0) : amountMinorNew;
  return Utils$OrcaPaymentPage.getJsonFromArrayOfJson([
              [
                "address",
                address
              ],
              [
                "chain",
                Utils$OrcaPaymentPage.getString(invoice, "chain", "")
              ],
              [
                "asset",
                Utils$OrcaPaymentPage.getString(invoice, "asset", "")
              ],
              [
                "tokenContract",
                Utils$OrcaPaymentPage.getString(invoice, "token_contract", "")
              ],
              [
                "amountMinor",
                amountMinor
              ],
              [
                "decimals",
                Utils$OrcaPaymentPage.getInt(invoice, "token_decimals", Utils$OrcaPaymentPage.getInt(invoice, "decimals", 6))
              ],
              [
                "expiryAt",
                invoiceExpirySeconds(invoice)
              ],
              [
                "cryptoInvoiceId",
                Utils$OrcaPaymentPage.getString(invoice, "id", "")
              ],
              [
                "paymentId",
                paymentId
              ],
              [
                "clientSecret",
                clientSecret
              ],
              [
                "profileId",
                profileId
              ],
              [
                "publishableKey",
                publishableKey
              ],
              [
                "apiVersion",
                "v2"
              ],
              [
                "url",
                returnUrl
              ]
            ]);
}

function intentCall(fetchApi, uri, headers, bodyStr, confirmParam, optLogger, handleUserError, paymentType, fetchMethod, customPodUri, sdkHandleOneClickConfirmPayment, isPaymentSessionOpt, isCallbackUsedVal, redirectionFlags) {
  var isPaymentSession = isPaymentSessionOpt !== undefined ? isPaymentSessionOpt : false;
  var isConfirm = uri.includes("/confirm");
  var handleOpenUrl = function (url) {
    if (isPaymentSession) {
      return Utils$OrcaPaymentPage.replaceRootHref(url, redirectionFlags);
    } else {
      return Utils$OrcaPaymentPage.openUrl(url);
    }
  };
  return Core__Promise.$$catch(fetchApi(uri, bodyStr, ApiEndpoint$OrcaPaymentPage.addCustomPodHeader(headers, customPodUri), fetchMethod, undefined, undefined, undefined, undefined).then(function (res) {
                  var url = new URL(confirmParam.return_url);
                  url.searchParams.set("status", "failed");
                  Utils$OrcaPaymentPage.messageParentWindow(undefined, [[
                          "confirmParams",
                          confirmParam
                        ]]);
                  if (res.ok) {
                    return res.json().then(function (data) {
                                return new Promise((function (resolve, param) {
                                                var intent = PaymentConfirmTypesV2$OrcaPaymentPage.itemToPMMConfirmMapper(Utils$OrcaPaymentPage.getDictFromJson(data));
                                                var paymentMethod;
                                                paymentMethod = "CARD";
                                                var url = new URL(confirmParam.return_url);
                                                url.searchParams.set("status", intent.authenticationDetails.status);
                                                var handleProcessingStatus = function (paymentType, sdkHandleOneClickConfirmPayment) {
                                                  var exit = 0;
                                                  switch (paymentType) {
                                                    case "Card" :
                                                        exit = 2;
                                                        break;
                                                    case "Gpay" :
                                                    case "Applepay" :
                                                    case "Paypal" :
                                                        exit = sdkHandleOneClickConfirmPayment ? 1 : 2;
                                                        break;
                                                    default:
                                                      exit = 1;
                                                  }
                                                  switch (exit) {
                                                    case 1 :
                                                        if (Core__Option.getOr(isCallbackUsedVal, false)) {
                                                          Utils$OrcaPaymentPage.closePaymentLoaderIfAny();
                                                          return Utils$OrcaPaymentPage.handleOnCompleteDoThisMessage(undefined);
                                                        } else {
                                                          return handleOpenUrl(url.href);
                                                        }
                                                    case 2 :
                                                        if (isPaymentSession) {
                                                          if (confirmParam.redirect === "always") {
                                                            if (Core__Option.getOr(isCallbackUsedVal, false)) {
                                                              return Utils$OrcaPaymentPage.handleOnCompleteDoThisMessage(undefined);
                                                            } else {
                                                              return handleOpenUrl(url.href);
                                                            }
                                                          } else {
                                                            return resolve(data);
                                                          }
                                                        } else {
                                                          if (Core__Option.getOr(isCallbackUsedVal, false)) {
                                                            Utils$OrcaPaymentPage.handleOnCompleteDoThisMessage(undefined);
                                                          } else {
                                                            Utils$OrcaPaymentPage.closePaymentLoaderIfAny();
                                                          }
                                                          return Utils$OrcaPaymentPage.postSubmitResponse(data, url.href);
                                                        }
                                                    
                                                  }
                                                };
                                                if (intent.authenticationDetails.status !== "requires_customer_action") {
                                                  if (intent.authenticationDetails.status !== "") {
                                                    if (intent.authenticationDetails.status === "succeeded") {
                                                      LoggerUtils$OrcaPaymentPage.handleLogging(optLogger, intent.authenticationDetails.status, "PAYMENT_SUCCESS", paymentMethod, undefined);
                                                    } else if (intent.authenticationDetails.status === "failed") {
                                                      LoggerUtils$OrcaPaymentPage.handleLogging(optLogger, intent.authenticationDetails.status, "PAYMENT_FAILED", paymentMethod, undefined);
                                                    }
                                                    return handleProcessingStatus(paymentType, sdkHandleOneClickConfirmPayment);
                                                  } else {
                                                    handleProcessingStatus(paymentType, sdkHandleOneClickConfirmPayment);
                                                    LoggerUtils$OrcaPaymentPage.handleLogging(optLogger, "succeeded", "PAYMENT_SUCCESS", paymentMethod, undefined);
                                                    return url.searchParams.set("status", "succeeded");
                                                  }
                                                }
                                                if (intent.nextAction.type_ === "redirect_to_url") {
                                                  LoggerUtils$OrcaPaymentPage.handleLogging(optLogger, "", "REDIRECTING_USER", paymentMethod, undefined);
                                                  return handleOpenUrl(intent.nextAction.redirectToUrl);
                                                }
                                                if (!isPaymentSession) {
                                                  Utils$OrcaPaymentPage.postFailedSubmitResponse("confirm_payment_failed", "Payment failed. Try again!");
                                                }
                                                if (uri.includes("force_sync=true")) {
                                                  LoggerUtils$OrcaPaymentPage.handleLogging(optLogger, intent.nextAction.type_, "REDIRECTING_USER", paymentMethod, "ERROR");
                                                  return handleOpenUrl(url.href);
                                                }
                                                var failedSubmitResponse = Utils$OrcaPaymentPage.getFailedSubmitResponse("confirm_payment_failed", "Payment failed. Try again!");
                                                resolve(failedSubmitResponse);
                                              })).then(function (prim) {
                                            return Promise.resolve(prim);
                                          });
                              });
                  } else {
                    return Core__Promise.$$catch(res.json().then(function (data) {
                                    return new Promise((function (resolve, param) {
                                                    if (isConfirm) {
                                                      var paymentMethod;
                                                      paymentMethod = paymentType === "Card" ? "CARD" : Utils$OrcaPaymentPage.getString(Utils$OrcaPaymentPage.getDictFromJson(Utils$OrcaPaymentPage.safeParse(bodyStr)), "payment_method_type", "");
                                                      LoggerUtils$OrcaPaymentPage.handleLogging(optLogger, JSON.stringify(data), "PAYMENT_FAILED", paymentMethod, undefined);
                                                    }
                                                    var dict = Utils$OrcaPaymentPage.getDictFromJson(data);
                                                    var errorObj = PaymentError$OrcaPaymentPage.itemToObjMapper(dict);
                                                    if (!isPaymentSession) {
                                                      Utils$OrcaPaymentPage.closePaymentLoaderIfAny();
                                                      Utils$OrcaPaymentPage.postFailedSubmitResponse(errorObj.error.type_, errorObj.error.message);
                                                    }
                                                    if (handleUserError) {
                                                      return handleOpenUrl(url.href);
                                                    }
                                                    var failedSubmitResponse = Utils$OrcaPaymentPage.getFailedSubmitResponse(errorObj.error.type_, errorObj.error.message);
                                                    resolve(failedSubmitResponse);
                                                  })).then(function (prim) {
                                                return Promise.resolve(prim);
                                              });
                                  }), (function (err) {
                                  return new Promise((function (resolve, param) {
                                                  Utils$OrcaPaymentPage.formatException(err);
                                                  if (!isPaymentSession) {
                                                    Utils$OrcaPaymentPage.closePaymentLoaderIfAny();
                                                    Utils$OrcaPaymentPage.postFailedSubmitResponse("server_error", "Something went wrong");
                                                  }
                                                  if (handleUserError) {
                                                    return handleOpenUrl(url.href);
                                                  }
                                                  var failedSubmitResponse = Utils$OrcaPaymentPage.getFailedSubmitResponse("server_error", "Something went wrong");
                                                  resolve(failedSubmitResponse);
                                                })).then(function (prim) {
                                              return Promise.resolve(prim);
                                            });
                                }));
                  }
                }), (function (err) {
                return new Promise((function (resolve, param) {
                                try {
                                  var url = new URL(confirmParam.return_url);
                                  url.searchParams.set("status", "failed");
                                  Utils$OrcaPaymentPage.formatException(err);
                                  if (!isPaymentSession) {
                                    Utils$OrcaPaymentPage.closePaymentLoaderIfAny();
                                    Utils$OrcaPaymentPage.postFailedSubmitResponse("server_error", "Something went wrong");
                                  }
                                  if (handleUserError) {
                                    return handleOpenUrl(url.href);
                                  }
                                  var failedSubmitResponse = Utils$OrcaPaymentPage.getFailedSubmitResponse("server_error", "Something went wrong");
                                  return resolve(failedSubmitResponse);
                                }
                                catch (exn){
                                  if (!isPaymentSession) {
                                    Utils$OrcaPaymentPage.postFailedSubmitResponse("error", "Something went wrong");
                                  }
                                  var failedSubmitResponse$1 = Utils$OrcaPaymentPage.getFailedSubmitResponse("server_error", "Something went wrong");
                                  return resolve(failedSubmitResponse$1);
                                }
                              })).then(function (prim) {
                            return Promise.resolve(prim);
                          });
              }));
}

function fetchPaymentManagementList(pmSessionId, endpoint, param, customPodUri, sdkAuthorization) {
  var headers = [[
      "Authorization",
      sdkAuthorization
    ]];
  var uri = endpoint + "/v1/payment-method-sessions/" + pmSessionId + "/list-payment-methods";
  return Core__Promise.$$catch(Utils$OrcaPaymentPage.fetchApi(uri, undefined, ApiEndpoint$OrcaPaymentPage.addCustomPodHeader(headers, customPodUri), "GET", undefined, undefined, undefined, undefined).then(function (res) {
                  if (res.ok) {
                    return res.json();
                  } else {
                    return res.json().then(function (param) {
                                return Promise.resolve(null);
                              });
                  }
                }), (function (err) {
                var exceptionMessage = Utils$OrcaPaymentPage.formatException(err);
                console.error("Error ", exceptionMessage);
                return Promise.resolve(null);
              }));
}

function deletePaymentMethodV2(paymentMethodToken, pmSessionId, param, customPodUri, sdkAuthorization) {
  var endpoint = ApiEndpoint$OrcaPaymentPage.getApiEndPoint(undefined, undefined);
  var headers = [[
      "Authorization",
      sdkAuthorization
    ]];
  var uri = endpoint + "/v1/payment-method-sessions/" + pmSessionId;
  return Core__Promise.$$catch(Utils$OrcaPaymentPage.fetchApi(uri, JSON.stringify(Utils$OrcaPaymentPage.getJsonFromArrayOfJson([[
                              "payment_method_token",
                              paymentMethodToken
                            ]])), ApiEndpoint$OrcaPaymentPage.addCustomPodHeader(headers, customPodUri), "DELETE", undefined, undefined, undefined, undefined).then(function (resp) {
                  if (resp.ok) {
                    return resp.json();
                  } else {
                    return resp.json().then(function (param) {
                                return Promise.resolve(null);
                              });
                  }
                }), (function (err) {
                var exceptionMessage = Utils$OrcaPaymentPage.formatException(err);
                console.error("Error ", exceptionMessage);
                return Promise.resolve(null);
              }));
}

function updatePaymentMethod(bodyArr, pmSessionId, param, customPodUri, sdkAuthorization) {
  var endpoint = ApiEndpoint$OrcaPaymentPage.getApiEndPoint(undefined, undefined);
  var headers = [[
      "Authorization",
      sdkAuthorization
    ]];
  var uri = endpoint + "/v1/payment-method-sessions/" + pmSessionId + "/update-saved-payment-method";
  return Core__Promise.$$catch(Utils$OrcaPaymentPage.fetchApi(uri, JSON.stringify(Utils$OrcaPaymentPage.getJsonFromArrayOfJson(bodyArr)), ApiEndpoint$OrcaPaymentPage.addCustomPodHeader(headers, customPodUri), "PUT", undefined, undefined, undefined, undefined).then(function (resp) {
                  if (resp.ok) {
                    return resp.json();
                  } else {
                    return resp.json().then(function (param) {
                                return Promise.resolve(null);
                              });
                  }
                }), (function (err) {
                var exceptionMessage = Utils$OrcaPaymentPage.formatException(err);
                console.error("Error ", exceptionMessage);
                return Promise.resolve(null);
              }));
}

function useSaveCard(optLogger, paymentType) {
  var paymentManagementList = Recoil.useRecoilValue(RecoilAtomsV2$OrcaPaymentPage.paymentManagementList);
  var keys = Recoil.useRecoilValue(RecoilAtoms$OrcaPaymentPage.keys);
  var sdkAuthorization = keys.sdkAuthorization;
  var customPodUri = Recoil.useRecoilValue(RecoilAtoms$OrcaPaymentPage.customPodUri);
  var isCallbackUsedVal = Recoil.useRecoilValue(RecoilAtoms$OrcaPaymentPage.isCompleteCallbackUsed);
  var redirectionFlags = Recoil.useRecoilValue(RecoilAtoms$OrcaPaymentPage.redirectionFlagsAtom);
  return function (handleUserErrorOpt, bodyArr, confirmParam) {
    var handleUserError = handleUserErrorOpt !== undefined ? handleUserErrorOpt : false;
    var pmSessionId = keys.pmSessionId;
    if (pmSessionId === undefined) {
      return Utils$OrcaPaymentPage.postFailedSubmitResponse("confirm_payment_failed", "Payment failed. Try again!");
    }
    var headers = [[
        "Authorization",
        Core__Option.getOr(sdkAuthorization, "")
      ]];
    var endpoint = ApiEndpoint$OrcaPaymentPage.getApiEndPoint(confirmParam.publishableKey, undefined);
    var uri = endpoint + "/v1/payment-method-sessions/" + pmSessionId + "/confirm";
    var returnUrlArr = [[
        "return_url",
        confirmParam.return_url
      ]];
    var bodyStr = JSON.stringify(Utils$OrcaPaymentPage.getJsonFromArrayOfJson(bodyArr.concat(BrowserSpec$OrcaPaymentPage.broswerInfo(), returnUrlArr)));
    var saveCard = function () {
      intentCall(Utils$OrcaPaymentPage.fetchApi, uri, headers, bodyStr, confirmParam, optLogger, handleUserError, paymentType, "POST", customPodUri, keys.sdkHandleOneClickConfirmPayment, undefined, isCallbackUsedVal, redirectionFlags);
    };
    if (typeof paymentManagementList !== "object" || paymentManagementList.TAG !== "LoadedV2") {
      return ;
    } else {
      return saveCard();
    }
  };
}

function useUpdateCard(optLogger, paymentType) {
  var paymentManagementList = Recoil.useRecoilValue(RecoilAtomsV2$OrcaPaymentPage.paymentManagementList);
  var keys = Recoil.useRecoilValue(RecoilAtoms$OrcaPaymentPage.keys);
  var sdkAuthorization = keys.sdkAuthorization;
  var customPodUri = Recoil.useRecoilValue(RecoilAtoms$OrcaPaymentPage.customPodUri);
  var isCallbackUsedVal = Recoil.useRecoilValue(RecoilAtoms$OrcaPaymentPage.isCompleteCallbackUsed);
  var redirectionFlags = Recoil.useRecoilValue(RecoilAtoms$OrcaPaymentPage.redirectionFlagsAtom);
  return function (handleUserErrorOpt, bodyArr, confirmParam) {
    var handleUserError = handleUserErrorOpt !== undefined ? handleUserErrorOpt : false;
    var pmSessionId = keys.pmSessionId;
    if (pmSessionId === undefined) {
      return Utils$OrcaPaymentPage.postFailedSubmitResponse("confirm_payment_failed", "Payment failed. Try again!");
    }
    var headers = [[
        "Authorization",
        Core__Option.getOr(sdkAuthorization, "")
      ]];
    var endpoint = ApiEndpoint$OrcaPaymentPage.getApiEndPoint(confirmParam.publishableKey, undefined);
    var uri = endpoint + "/v1/payment-method-sessions/" + pmSessionId + "/update-saved-payment-method";
    var returnUrlArr = [[
        "return_url",
        confirmParam.return_url
      ]];
    var bodyStr = JSON.stringify(Utils$OrcaPaymentPage.getJsonFromArrayOfJson(bodyArr.concat(BrowserSpec$OrcaPaymentPage.broswerInfo(), returnUrlArr)));
    var updateCard = function () {
      intentCall(Utils$OrcaPaymentPage.fetchApi, uri, headers, bodyStr, confirmParam, optLogger, handleUserError, paymentType, "PUT", customPodUri, keys.sdkHandleOneClickConfirmPayment, undefined, isCallbackUsedVal, redirectionFlags);
    };
    if (typeof paymentManagementList !== "object" || paymentManagementList.TAG !== "LoadedV2") {
      return ;
    } else {
      return updateCard();
    }
  };
}

function retrievePaymentIntentV2(paymentId, clientSecret, publishableKey, profileId, customPodUri) {
  var uri = APIUtils$OrcaPaymentPage.generateApiUrlV2({
        publishableKey: publishableKey,
        customBackendBaseUrl: undefined,
        paymentId: paymentId
      }, "GetIntentV2");
  var headers = APIUtils$OrcaPaymentPage.v2ClientAuthHeaders(publishableKey, clientSecret, profileId);
  return Core__Promise.$$catch(Utils$OrcaPaymentPage.fetchApi(uri, undefined, ApiEndpoint$OrcaPaymentPage.addCustomPodHeader(headers, customPodUri), "GET", undefined, undefined, undefined, undefined).then(function (res) {
                  if (res.ok) {
                    return res.json();
                  } else {
                    return res.json().then(function (param) {
                                return Promise.resolve(null);
                              });
                  }
                }), (function (err) {
                console.error("v2 get-intent error ", Utils$OrcaPaymentPage.formatException(err));
                return Promise.resolve(null);
              }));
}

function checkoutCryptoInstructionV2(paymentId, clientSecret, publishableKey, profileId, cryptoPayload, confirmParam, iframeId, handleUserError, customPodUri) {
  var uri = APIUtils$OrcaPaymentPage.generateApiUrlV2({
        publishableKey: publishableKey,
        customBackendBaseUrl: undefined,
        paymentId: paymentId
      }, "CheckoutCryptoInstructionV2");
  var headers = APIUtils$OrcaPaymentPage.v2ClientAuthHeaders(publishableKey, clientSecret, profileId);
  var url = new URL(confirmParam.return_url);
  url.searchParams.set("status", "requires_customer_action");
  return Core__Promise.$$catch(Utils$OrcaPaymentPage.fetchApi(uri, JSON.stringify(cryptoPayload), ApiEndpoint$OrcaPaymentPage.addCustomPodHeader(headers, customPodUri), "POST", undefined, undefined, undefined, undefined).then(function (res) {
                  return res.json().then(function (data) {
                              return new Promise((function (resolve, param) {
                                            var dict = Utils$OrcaPaymentPage.getDictFromJson(data);
                                            if (res.ok) {
                                              var invoice = Core__Option.flatMap(dict["invoice"], Core__JSON.Decode.object);
                                              var invoice$1 = invoice !== undefined ? invoice : Core__Option.getOr(Core__Option.flatMap(dict["crypto_invoice"], Core__JSON.Decode.object), {});
                                              var metaData = buildNativeCryptoMetadata(invoice$1, paymentId, clientSecret, profileId, publishableKey, url.href);
                                              Utils$OrcaPaymentPage.messageParentWindow(undefined, [
                                                    [
                                                      "fullscreen",
                                                      true
                                                    ],
                                                    [
                                                      "param",
                                                      "nativeCryptoData"
                                                    ],
                                                    [
                                                      "iframeId",
                                                      iframeId
                                                    ],
                                                    [
                                                      "metadata",
                                                      metaData
                                                    ]
                                                  ]);
                                              return resolve(data);
                                            }
                                            var errorObj = PaymentError$OrcaPaymentPage.itemToObjMapper(dict);
                                            Utils$OrcaPaymentPage.closePaymentLoaderIfAny();
                                            Utils$OrcaPaymentPage.postFailedSubmitResponse(errorObj.error.type_, errorObj.error.message);
                                            if (handleUserError) {
                                              url.searchParams.set("status", "failed");
                                              return Utils$OrcaPaymentPage.openUrl(url.href);
                                            } else {
                                              return resolve(Utils$OrcaPaymentPage.getFailedSubmitResponse(errorObj.error.type_, errorObj.error.message));
                                            }
                                          }));
                            });
                }), (function (err) {
                Utils$OrcaPaymentPage.formatException(err);
                Utils$OrcaPaymentPage.closePaymentLoaderIfAny();
                Utils$OrcaPaymentPage.postFailedSubmitResponse("server_error", "Something went wrong");
                return Promise.resolve(Utils$OrcaPaymentPage.getFailedSubmitResponse("server_error", "Something went wrong"));
              }));
}

function confirmIntentV2(paymentId, clientSecret, publishableKey, profileId, bodyArr, confirmParam, iframeId, handleUserError, customPodUri, optLogger, paymentType) {
  var uri = APIUtils$OrcaPaymentPage.generateApiUrlV2({
        publishableKey: publishableKey,
        customBackendBaseUrl: undefined,
        paymentId: paymentId
      }, "ConfirmIntentV2");
  var headers = APIUtils$OrcaPaymentPage.v2ClientAuthHeaders(publishableKey, clientSecret, profileId);
  var bodyStr = JSON.stringify(Utils$OrcaPaymentPage.getJsonFromArrayOfJson(bodyArr));
  var paymentMethod;
  paymentMethod = "CARD";
  return Core__Promise.$$catch(Utils$OrcaPaymentPage.fetchApi(uri, bodyStr, ApiEndpoint$OrcaPaymentPage.addCustomPodHeader(headers, customPodUri), "POST", undefined, undefined, undefined, undefined).then(function (res) {
                  var url = new URL(confirmParam.return_url);
                  Utils$OrcaPaymentPage.messageParentWindow(undefined, [[
                          "confirmParams",
                          confirmParam
                        ]]);
                  return res.json().then(function (data) {
                              return new Promise((function (resolve, param) {
                                              var dict = Utils$OrcaPaymentPage.getDictFromJson(data);
                                              if (res.ok) {
                                                var intent = PaymentConfirmTypesV2$OrcaPaymentPage.itemToPaymentResponseMapper(dict);
                                                url.searchParams.set("status", intent.status);
                                                var match = intent.status;
                                                switch (match) {
                                                  case "requires_customer_action" :
                                                      var match$1 = intent.nextAction.type_;
                                                      switch (match$1) {
                                                        case "display_crypto_invoice" :
                                                            var invoiceActionData = Core__Option.getOr(Core__Option.flatMap(intent.nextAction.next_action_data, Core__JSON.Decode.object), {});
                                                            var invoice = Core__Option.getOr(Core__Option.flatMap(invoiceActionData["invoice"], Core__JSON.Decode.object), {});
                                                            var metaData = buildNativeCryptoMetadata(invoice, paymentId, clientSecret, profileId, publishableKey, url.href);
                                                            Utils$OrcaPaymentPage.messageParentWindow(undefined, [
                                                                  [
                                                                    "fullscreen",
                                                                    true
                                                                  ],
                                                                  [
                                                                    "param",
                                                                    "nativeCryptoData"
                                                                  ],
                                                                  [
                                                                    "iframeId",
                                                                    iframeId
                                                                  ],
                                                                  [
                                                                    "metadata",
                                                                    metaData
                                                                  ]
                                                                ]);
                                                            break;
                                                        case "redirect_to_url" :
                                                            LoggerUtils$OrcaPaymentPage.handleLogging(optLogger, "", "REDIRECTING_USER", paymentMethod, undefined);
                                                            Utils$OrcaPaymentPage.openUrl(intent.nextAction.redirectToUrl);
                                                            break;
                                                        default:
                                                          Utils$OrcaPaymentPage.closePaymentLoaderIfAny();
                                                          Utils$OrcaPaymentPage.postFailedSubmitResponse("confirm_payment_failed", "Payment requires an unsupported action.");
                                                      }
                                                      return resolve(data);
                                                  case "cancelled" :
                                                  case "failed" :
                                                  case "partially_captured" :
                                                  case "processing" :
                                                  case "succeeded" :
                                                      break;
                                                  default:
                                                    return resolve(data);
                                                }
                                                LoggerUtils$OrcaPaymentPage.handleLogging(optLogger, intent.status, intent.status === "failed" ? "PAYMENT_FAILED" : "PAYMENT_SUCCESS", paymentMethod, undefined);
                                                Utils$OrcaPaymentPage.closePaymentLoaderIfAny();
                                                Utils$OrcaPaymentPage.postSubmitResponse(data, url.href);
                                                return resolve(data);
                                              }
                                              var errorObj = PaymentError$OrcaPaymentPage.itemToObjMapper(dict);
                                              LoggerUtils$OrcaPaymentPage.handleLogging(optLogger, JSON.stringify(data), "PAYMENT_FAILED", paymentMethod, undefined);
                                              Utils$OrcaPaymentPage.closePaymentLoaderIfAny();
                                              Utils$OrcaPaymentPage.postFailedSubmitResponse(errorObj.error.type_, errorObj.error.message);
                                              if (handleUserError) {
                                                url.searchParams.set("status", "failed");
                                                return Utils$OrcaPaymentPage.openUrl(url.href);
                                              } else {
                                                return resolve(Utils$OrcaPaymentPage.getFailedSubmitResponse(errorObj.error.type_, errorObj.error.message));
                                              }
                                            })).then(function (prim) {
                                          return Promise.resolve(prim);
                                        });
                            });
                }), (function (err) {
                Utils$OrcaPaymentPage.formatException(err);
                Utils$OrcaPaymentPage.closePaymentLoaderIfAny();
                Utils$OrcaPaymentPage.postFailedSubmitResponse("server_error", "Something went wrong");
                return Promise.resolve(Utils$OrcaPaymentPage.getFailedSubmitResponse("server_error", "Something went wrong"));
              }));
}

export {
  normalizeIsoUtc ,
  invoiceExpirySeconds ,
  buildNativeCryptoMetadata ,
  intentCall ,
  fetchPaymentManagementList ,
  deletePaymentMethodV2 ,
  updatePaymentMethod ,
  useSaveCard ,
  useUpdateCard ,
  retrievePaymentIntentV2 ,
  checkoutCryptoInstructionV2 ,
  confirmIntentV2 ,
}
/* recoil Not a pure module */
